import { createContext } from 'react'

import { IAppHeaderSettings } from 'src/core/components/app/models/IAppHeaderSettings'
import { IAppUserSettings } from 'src/core/components/app/models/IAppSettings'

import { EDIT_MODE_ACCESS_ROLES_DEFAULT } from './constants'

export interface IAppContext {
  headerSettings: IAppHeaderSettings
  userSettings?: IAppUserSettings
}

export const AppContext = createContext<IAppContext>({
  headerSettings: {
    editModeAccessRoles: EDIT_MODE_ACCESS_ROLES_DEFAULT,
    profileChangeUserSettingsVisible: false,
  },
})
